export interface CollabUser {
  id: string;
  name: string;
  color: string;
  avatarUrl?: string;
}

export interface CollabConfig {
  roomId: string;
  user: CollabUser;
}

export interface CollabCommentData {
  userId: string;
  userName: string;
  userAvatar?: string;
}

const COLLAB_USER_COLORS = [
  '#fb7185',
  '#fdba74',
  '#d9f99d',
  '#a7f3d0',
  '#a5f3fc',
  '#a5b4fc',
  '#f0abfc',
  '#fda58d',
  '#f2cc8f',
  '#9ae6b4',
  '#fca5a5',
  '#fcd34d',
  '#86efac',
  '#67e8f9',
  '#c4b5fd',
  '#f9a8d4',
  '#fdcfe8',
  '#bef264',
  '#5eead4',
  '#93c5fd',
  '#e879f9',
  '#fbbf24',
  '#34d399',
  '#22d3ee',
  '#818cf8',
  '#fb923c',
  '#a3e635',
  '#2dd4bf',
  '#60a5fa',
  '#c084fc',
];

export function getCollabColorForUserId(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) - hash + userId.charCodeAt(i)) | 0;
  }
  return COLLAB_USER_COLORS[Math.abs(hash) % COLLAB_USER_COLORS.length] ?? '#9ae6b4';
}
